export default "__VITE_ASSET__97444ed0__"